export const LOGIN = "/auth/login";
export const VERIFY = "/auth/login/verify";

//Admin
export const ADMIN_LOGIN = "/auth/admin/login";
export const STATE_DISTRICT = "/state/district";
export const STATE_BLOCK = "/state/district";
export const STATE_SCHOOL = "/state/school";
export const STATE_STUDENT = "/state/student";
export const STATE_STUDENT_ID = "/state/students-details";

export const SEND_FORGOT_OTP = "/auth/admin/send-reset-otp";
export const CHANGE_PASSWORD = "/auth/admin/update-password";
export const RESET_PASSWORD_OTP = "/auth/admin/send-reset-otp-for-beo-deo"
export const RESET_PASSWORD = "/auth/admin/update-password-for-beo-deo"


//school
export const DISTRICT_DASHBOARD = "/district/dashboard";
export const DISTRICT_BLOCK = "/district/blocks";
export const DISTRICT_SCHOOL = "/district/schools";
export const DISTRICT_STUDENT = "/district/students";
export const DISTRICT_STUDENT_ID = "/district/students-details";
export const GET_DISTRICT_SCHOOL = "/district/schools";
export const GET_DISTRICT_SCHOOL_NEW = "/district/all-schools";
export const UPDATE_EMAIL_DISTRCT = "/district/update-school-email";
export const GET_SCHOOL_SEATS = "/district/school-seats/";
export const APPROVE_SEATS = "/district/approve-seats";
export const RECHECK_SEATS = "/district/recheck-seats";
export const PAYMET_URL = "/school/get-redirect-school-url-v3";


//DEO
export const BLOCK_DASHBOARD = "/block/dashboard";
export const BLOCK_SCHOOL = "/block/schools";
export const BLOCK_STUDENT = "/block/students";
export const BLOCK_STUDENT_ID = "/block/students-details";

//DEO
export const SCHOOL_DASHBOARD = "/school/dashboard";
export const SCHOOL_STUDENT = "/school/students";
export const SCHOOL_STUDENT_ID = "/school/students-details";
export const VIEW_SCHOOL_SEATS = "/school/view-school-seats";
export const ADD_SCHOOL_SEATS = "/school/add-school-seats";
export const UPDATE_SCHOOL_SEATS = "/school/update-school-seats";
export const DELETE_SCHOOL_SEATS = "/school/delete-school-seats/";


//RANDOMIZATION
export const RANDOMIZATION = "/district/randomization_fifth";
export const GET_ALLOTMENT_DATA = "/district/allotment-data/";





